import { FaPhone } from "react-icons/fa";
import './CallBarMoshe.css';

const CallBarMoshe = () => {
  const handleClick = () => {
    if (window.gtag) {
      window.gtag('event', 'call_moshe_bar', {
        event_category: 'Insurance CTA',
        event_label: 'Call Bar at Bottom',
        value: 1,
      });
    }
  };

  return (
    <a
      href="tel:+972509139000"
      className="CallBarMoshe"
      onClick={handleClick}
    >
      <FaPhone className="CallBarMosheIcon" />
      <span className="CallBarMosheText">חייג למשה ציון וקבל הצעה משתלמת לביטוח מונית</span>
    </a>
  );
};

export default CallBarMoshe;
